import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const branchesForCarrierWithIdQueryKey = (carrierId: number | string | undefined) => [
  ...namedQueryKeyWithId("carriers", carrierId),
  "branches",
];
